import React from 'react';
import MasteredShield from './MasteredShield';
import { BAND_BAR, formatMultiplier, rateTag } from './homeRates';

const TAG_STYLE = {
  red: 'bg-red-50 text-red-700',
  amber: 'bg-amber-50 text-amber-800',
  green: 'bg-green-50 text-green-800',
  grey: 'bg-[#F0EDFA] text-[#5C3BD1]',
  above: 'bg-[#F0EDFA] text-[#5C3BD1]',
  warmUp: 'bg-gray-100 text-gray-700',
};

/**
 * A Home Learning lesson's score bar (the colour and score that set its Sparks), a shield once mastered, and a
 * short tag saying what it pays. `showTag` is off when the lesson already earned today: that chip says it instead.
 */
export default function LessonRate({ rate, showTag = true }) {
  if (!rate) return null;
  const tag = showTag ? rateTag(rate) : null;
  const pct = rate.bandPercent ?? 0;
  const multiplier = formatMultiplier(rate.multiplier);
  return (
    <div className="mt-1 flex flex-wrap items-center gap-2 text-xs font-normal" data-testid="lesson-rate">
      <div
        className="h-2 w-24 overflow-hidden rounded-full bg-gray-200"
        role="img"
        aria-label={rate.bandPercent === null ? 'Not tried yet' : `Your score: ${rate.bandPercent}%`}
      >
        <div className={`h-full rounded-full ${BAND_BAR[rate.band]}`} style={{ width: `${pct}%` }} data-testid="lesson-rate-bar" />
      </div>
      {rate.band === 'green' && <MasteredShield size={18} />}
      {tag && (
        <span className={`rounded-full px-2 py-0.5 font-semibold ${TAG_STYLE[tag.key]}`} data-testid="lesson-rate-tag">
          {tag.text}
          {multiplier && <span className="ml-1 opacity-80">{multiplier}</span>}
        </span>
      )}
    </div>
  );
}
